module.exports = __webpack_public_path__ + "static/media/1974-75_HP.c615c9a7.pdf";